import SvgIcon from '@mui/material/SvgIcon';
import { FC, memo, lazy, Suspense } from 'react';

// Utilizzare lazy imports per ogni icona
const BagsShopping = lazy(
  () => import('../assets/service-icon/bags-shopping.svg?react')
);
const BirthdayCake = lazy(
  () => import('../assets/service-icon/birthday-cake.svg?react')
);
const Briefcase = lazy(
  () => import('../assets/service-icon/briefcase.svg?react')
);
const Camera = lazy(() => import('../assets/service-icon/camera.svg?react'));
const ContactLens = lazy(
  () => import('../assets/service-icon/contact-lens.svg?react')
);
const Child = lazy(() => import('../assets/service-icon/child.svg?react'));
const ConciergeBell = lazy(
  () => import('../assets/service-icon/concierge-bell.svg?react')
);
const Ear = lazy(() => import('../assets/service-icon/ear.svg?react'));
const Eye = lazy(() => import('../assets/service-icon/eye.svg?react'));
const EyeTest = lazy(() => import('../assets/service-icon/eye-test.svg?react'));
const Female = lazy(() => import('../assets/service-icon/female.svg?react'));
const FontCase = lazy(
  () => import('../assets/service-icon/font-case.svg?react')
);
const Gem = lazy(() => import('../assets/service-icon/gem.svg?react'));
const GiftCard = lazy(
  () => import('../assets/service-icon/gift-card.svg?react')
);
const GlassCheers = lazy(
  () => import('../assets/service-icon/glass-cheers.svg?react')
);
const Glasses = lazy(() => import('../assets/service-icon/glasses.svg?react'));
const HandsHeart = lazy(
  () => import('../assets/service-icon/hands-heart.svg?react')
);
const HouseReturn = lazy(
  () => import('../assets/service-icon/house-return.svg?react')
);
const LowVision = lazy(
  () => import('../assets/service-icon/low-vision.svg?react')
);
const Male = lazy(() => import('../assets/service-icon/male.svg?react'));
const ParkingCicle = lazy(
  () => import('../assets/service-icon/parking-circle.svg?react')
);
const PeopleArrows = lazy(
  () => import('../assets/service-icon/people-arrows.svg?react')
);
const Screwdriver = lazy(
  () => import('../assets/service-icon/screwdriver.svg?react')
);
const ShoppingCart = lazy(
  () => import('../assets/service-icon/shopping-cart.svg?react')
);
const Skiing = lazy(() => import('../assets/service-icon/skiing.svg?react'));
const Star = lazy(() => import('../assets/service-icon/star.svg?react'));
const Sunglasses = lazy(
  () => import('../assets/service-icon/sunglasses.svg?react')
);
const Swimmer = lazy(() => import('../assets/service-icon/swimmer.svg?react'));
const TrafficLight = lazy(
  () => import('../assets/service-icon/traffic-light.svg?react')
);
const UserCrown = lazy(
  () => import('../assets/service-icon/user-crown.svg?react')
);
const UserFriends = lazy(
  () => import('../assets/service-icon/user-friends.svg?react')
);
const UserInjured = lazy(
  () => import('../assets/service-icon/user-injured.svg?react')
);
const UserMd = lazy(() => import('../assets/service-icon/user-md.svg?react'));
const UserShield = lazy(
  () => import('../assets/service-icon/user-shield.svg?react')
);
const User = lazy(() => import('../assets/service-icon/user.svg?react'));
const Users = lazy(() => import('../assets/service-icon/users.svg?react'));
const Watch = lazy(() => import('../assets/service-icon/watch.svg?react'));
const Wheelchair = lazy(
  () => import('../assets/service-icon/wheelchair.svg?react')
);

// Componente fallback per quando l'icona è in caricamento
const IconFallback = () => (
  <SvgIcon
    style={{
      color: 'var(--icon-color)',
      height: '20px',
      width: '20px',
    }}
  />
);

const iconMap: {
  [key: string]: {
    icon: any;
    viewBox: string;
  };
} = {
  'contact-lens': {
    icon: ContactLens,
    viewBox: '0 0 24 24',
  },
  'font-case': {
    icon: FontCase,
    viewBox: '0 0 640 512',
  },
  eye: {
    icon: Eye,
    viewBox: '0 0 576 512',
  },
  'eye-test': {
    icon: EyeTest,
    viewBox: '0 0 24 24',
  },
  'people-arrows': { icon: PeopleArrows, viewBox: '0 0 576 512' },
  'low-vision': { icon: LowVision, viewBox: '0 0 576 512' },
  'house-return': { icon: HouseReturn, viewBox: '0 0 640 512' },
  screwdriver: { icon: Screwdriver, viewBox: '0 0 512 512' },
  glasses: { icon: Glasses, viewBox: '0 0 576 512' },
  sunglasses: { icon: Sunglasses, viewBox: '0 0 576 512' },
  'bags-shopping': { icon: BagsShopping, viewBox: '0 0 576 512' },
  camera: { icon: Camera, viewBox: '0 0 512 512' },
  gem: { icon: Gem, viewBox: '0 0 576 512' },
  briefcase: { icon: Briefcase, viewBox: '0 0 512 512' },
  ear: { icon: Ear, viewBox: '0 0 384 512' },
  child: { icon: Child, viewBox: '0 0 448 512' },
  'glass-cheers': { icon: GlassCheers, viewBox: '0 0 640 512' },
  star: { icon: Star, viewBox: '0 0 576 512' },
  'traffic-light': { icon: TrafficLight, viewBox: '0 0 384 512' },
  watch: { icon: Watch, viewBox: '0 0 384 512' },
  'concierge-bell': { icon: ConciergeBell, viewBox: '0 0 512 512' },
  'user-md': { icon: UserMd, viewBox: '0 0 448 512' },
  'gift-card': { icon: GiftCard, viewBox: '0 0 576 512' },
  'shopping-cart': { icon: ShoppingCart, viewBox: '0 0 576 512' },
  'user-injured': { icon: UserInjured, viewBox: '0 0 448 512' },
  'user-shield': { icon: UserShield, viewBox: '0 0 640 512' },
  'user-crown': { icon: UserCrown, viewBox: '0 0 448 512' },
  'user-friends': { icon: UserFriends, viewBox: '0 0 640 512' },
  female: { icon: Female, viewBox: '0 0 320 512' },
  male: { icon: Male, viewBox: '0 0 256 512' },
  users: { icon: Users, viewBox: '0 0 640 512' },
  swimmer: { icon: Swimmer, viewBox: '0 0 640 512' },
  skiing: { icon: Skiing, viewBox: '0 0 512 512' },
  user: { icon: User, viewBox: '0 0 448 512' },
  'hands-heart': { icon: HandsHeart, viewBox: '0 0 640 512' },
  'parking-circle': { icon: ParkingCicle, viewBox: '0 0 496 512' },
  'birthday-cake': { icon: BirthdayCake, viewBox: '0 0 448 512' },
  wheelchair: { icon: Wheelchair, viewBox: '0 0 512 512' },
};

export const DynamicIconConverter: FC<{ name: string }> = memo(({ name }) => {
  const IconComponent: { icon: any; viewBox: string } | null =
    name in iconMap ? iconMap[name] : null;

  if (IconComponent === null) return null;

  return (
    <Suspense fallback={<IconFallback />}>
      <SvgIcon
        component={IconComponent.icon}
        style={{ color: 'var(--icon-color)', height: '20px', width: '20px' }}
        viewBox={IconComponent.viewBox}
      />
    </Suspense>
  );
});
